var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(" Личный кабинет ")]),_c('div',{staticClass:"text"},[_vm._v(" Информируем, что личный кабинет участника конкурса \"Лидеры России.Политика\" закрыт в связи с завершением отборочных этапов. ")])])
}]

export { render, staticRenderFns }